import { Repository } from '../repository';
import { type Technique } from './entity';

export class Techniques extends Repository<Technique> {
    private readonly prefix = 'CT';

    getByLabel(label: string): Technique | undefined {
        return this.items.find((technique) => technique.label === label);
    }

    getNextLabel(): string {
        const customItems = this.items.filter((tactic) => tactic.isCustom);
        const lastCustomItem = customItems[customItems.length - 1];
        if (!lastCustomItem) {
            return `${this.prefix}00001`;
        }
        const nr = parseInt(
            lastCustomItem.label?.slice(this.prefix.length) ?? '0',
        );
        const newNr = nr + 1;
        return `${this.prefix}${newNr.toString().padStart(5, '0')}`;
    }
}
